// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"13599e259a98b87ed009","453":"06601c73222a406ce73e","522":"9120a9c9bc3af00d07b6"}[chunkId] + ".js";
};